import React from 'react';
import './Intro.css';
import Button from '../Button/Button';
import Heading from '../Heading/Heading';
import { useTranslation } from 'react-i18next';

const Intro = ({ location }) => {

     // get translations
    const {t} = useTranslation();

    // render html
    return(
        <div className={`intro`}>
            <div className={`intro__box`}>
                <Heading size="m">{t('intro_heading')}</Heading>
                <div className={`intro__actions`}>
                    <Button path={`/${location}/nl`} type="language">Nederlands <span>»</span></Button>
                    <Button path={`/${location}/fr`} type="language">Français <span>»</span></Button>
                </div>
            </div>
        </div>
    );
}

export default Intro;